import comjs from "@/common/comjs";
import cmfnt from "@/common/cmfnt";
import utils from "@/common/utils";
import validates from "@/common/validates";
// 详情导出（html2canvas/jspdf）勿在此 re-export，否则会打进全局入口；由详情页按需加载
export default {
  comjs,
  cmfnt,
  utils,
  validates
}
